import {MacroItemTypeValue} from 'common/src/modules/macros/macros.types';
import {OutputType} from 'common/src/modules/nodes/nodes.types';
import {ConditionNodeOutputData} from 'common/src/modules/decisionTree/decisionTree.types';
import {DateTime} from 'luxon';
import {ConditionOperatorKey} from 'common/src/modules/conditions/conditions.types';

/**
 * Updates a fallback output with default values based on the condition type.
 * This ensures the fallback output has the same structure as regular outputs.
 */
function updateFallbackOutputWithDefaultValues(
  fallbackOutput: ConditionNodeOutputData,
  condKeyType: MacroItemTypeValue,
  condOperator: ConditionOperatorKey,
): void {
  // Text types
  if ([MacroItemTypeValue.Text, MacroItemTypeValue.TextList].includes(condKeyType)) {
    fallbackOutput.textValues = [];
  }

  // Numeric types
  if (condKeyType === MacroItemTypeValue.Numeric) {
    if (condOperator === ConditionOperatorKey.Between) {
      fallbackOutput.numbersRange = {from: 0, to: 0};
    } else {
      fallbackOutput.numericValues = [0];
    }
  }

  // Date types
  if ([MacroItemTypeValue.Date, MacroItemTypeValue.DateList].includes(condKeyType)) {
    if (condOperator === ConditionOperatorKey.Between) {
      const now = DateTime.now().toUTC();

      fallbackOutput.datesRange = {from: now, to: now};
    } else {
      fallbackOutput.dateValues = [DateTime.now().toUTC()];
    }
  }

  // Boolean/Condition types
  if (condKeyType === MacroItemTypeValue.Condition) {
    fallbackOutput.booleanValue = false;
  }

  // Ensure the output type is set correctly
  fallbackOutput.type = OutputType.Fallback;
}

export default updateFallbackOutputWithDefaultValues;
